import React from "react";

interface Props {
    title: string;
    help?: string;
    open: boolean;
    onToggle: () => void;
    children: React.ReactNode;
}

/**
 * Collapsible group inside Invoice "Customize defaults".
 */
const InvoiceDefaultsGroup: React.FC<Props> = ({title, help, open, onToggle, children}) => (
    <div className="border rounded mb-2 bg-white">
        <button
            type="button"
            className="w-100 d-flex align-items-center justify-content-between px-3 py-2 btn btn-light border-0 text-start"
            onClick={onToggle}
            aria-expanded={open}
        >
            <span className="fw-semibold small">{title}</span>
            <span className="text-muted small" aria-hidden>{open ? "−" : "+"}</span>
        </button>
        {open ? (
            <div className="px-3 pb-3 pt-1 border-top">
                {help ? <p className="text-muted small mb-2">{help}</p> : null}
                {children}
            </div>
        ) : null}
    </div>
);

export default React.memo(InvoiceDefaultsGroup);
